'use strict';

import CountryCodes from 'App/services/CountryCodes';

angular.module('services.countryCodes', []).factory('CountryCodes', [
	'$q',
	function ($q) {
		const wrapped = {
			...CountryCodes,
			find: filters => $q.when(CountryCodes.find(filters)),
			customer: () => wrapped
		};
		return wrapped;
	}
]);
